import { AttachmentComponent } from '../pages/attachment/attachment.component';
import { ConfirmationComponent } from '../pages/confirmation/confirmation.component';
import { ContactInfoComponent } from '../pages/contact-info/contact-info.component';
import { DegreeComponent } from '../pages/degree/degree.component';
import { OtherQualificationComponent } from '../pages/other-qualification/other-qualification.component';
import { ReviewComponent } from '../pages/review/review.component';
import { SpecialEducationComponent } from '../pages/special-education/special-education.component';
import { StartComponent } from '../pages/start/start.component';
import { VocationalQualificationComponent } from '../pages/vocational-qualification/vocational-qualification.component';
import { ANSOKAN_ROUTING_NAMES } from './ansokan.routes.names';

export const ANSOKAN_ROUTES = [
    { path: ANSOKAN_ROUTING_NAMES.START, component: StartComponent },
    { path: ANSOKAN_ROUTING_NAMES.CONTACT_INFO, component: ContactInfoComponent },
    { path: ANSOKAN_ROUTING_NAMES.DEGREE, component: DegreeComponent },
    { path: ANSOKAN_ROUTING_NAMES.VOCATIONAL_QUALIFICATION, component: VocationalQualificationComponent },
    { path: ANSOKAN_ROUTING_NAMES.OTHER_QUALIFICATION, component: OtherQualificationComponent },
    { path: ANSOKAN_ROUTING_NAMES.SPECIAL_EDUCATION_TEACHER, component: SpecialEducationComponent },
    { path: ANSOKAN_ROUTING_NAMES.ATTACHMENT, component: AttachmentComponent },
    { path: ANSOKAN_ROUTING_NAMES.REVIEW, component: ReviewComponent },
    { path: ANSOKAN_ROUTING_NAMES.CONFIRMATION, component: ConfirmationComponent },
];
